import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';

import {FAN_PROTECT_LINKS} from '@stubhub/general-utils';
import Countries from '@stubhub/react-localization-selector';

import {UK} from './constants';
import FooterLinks from './footer-links';

const RestrictionsLink = (msg) => (
  <a id="restrictions" href="/legal/?section=fp" title="Restrictions">
    {msg}
  </a>
);

class FooterTop extends Component {
  render() {
    const {globalRegistry} = this.context;
    const {isHomepage} = this.props;
    const store_id = globalRegistry.getStoreId();
    const locale = globalRegistry.getCurrentLocale()?.toLowerCase();
    const fan_protect_url = FAN_PROTECT_LINKS[locale] || FAN_PROTECT_LINKS.default;
    let guarantee;

    const isDE = globalRegistry.getFeatureValue('homepage.footer.deFanProtect');

    if (store_id === UK) {
      guarantee = (
        <FormattedMessage
          id="Footer.trust-safety-guarantee-uk"
          defaultMessage="Every order is 100% guaranteed. <a>Restrictions</a> apply."
          tagName="p"
          values={{
            a: RestrictionsLink,
          }}
        />
      );
    } else {
      guarantee = (
        <FormattedMessage id="Footer.trust-safety-guarantee" defaultMessage="Every order is 100% guaranteed" />
      );
    }

    return (
      <div className="footer-top">
        <div className="fan-protect">
          <a href={fan_protect_url} aria-label="Fan Protect" data-test-id="fan-protect-link">
            <div className={`fan-protect-img${isDE ? ' fan-protect-img-de' : ''}`} />
          </a>
          <div id="trust-lang">
            <span id="trust-safety-confidence">
              <FormattedMessage id="Footer.trust-safety-confidence" defaultMessage="Buy and sell with confidence" />
            </span>
            <span id="trust-safety-service">
              <FormattedMessage
                id="Footer.trust-safety-service"
                defaultMessage="Customer service all the way to your seat"
              />
            </span>
            <span id="trust-safety-guarantee">{guarantee}</span>
          </div>
        </div>
        <FooterLinks />
        <Countries isHomepage={isHomepage} />
      </div>
    );
  }
}

FooterTop.propTypes = {
  isHomepage: PropTypes.bool,
};

FooterTop.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default injectIntl(FooterTop);
